module.exports = __webpack_public_path__ + "static/media/bannerImage.53f8f539.png";